// The change card in the platform agent's panel (D5). Wording from the Amigo design's copy sheet (Card, Rejecting,
// Summary first, Row status, Applying, Done, Rejected, Replaced, Changed in the meantime, Partly failed).
export default {
  loading: 'Caricamento della modifica…',
  load_failed: 'Impossibile caricare questa modifica.',
  load_retry: 'Riprova',
  // An approve that found the set approved already, in another tab or by the agent's follow-up (QA19).
  already_approved: "Questa modifica era già stata approvata, quindi non c'era nient'altro da fare.",
  action_failed: 'Operazione non riuscita, nulla è cambiato. Riprova tra un attimo.',
  removed: 'Rimosso',
  retry: 'Riprova',
  retry_one: 'Riprova {{name}}',
  // The message the panel sends the agent with the card's outcome (contracts §5 clientContext.changeSet).
  message: {
    approved: 'Approvato.',
    retried: 'Riprovato.',
    rejected: 'Rifiutato.',
  },
  done: {
    summary_one: 'Fatto. {{count}} modifica applicata.',
    summary_other: 'Fatto. {{count}} modifiche applicate.',
    skipped_one: '{{count}} saltata, nulla è cambiato.',
    skipped_other: '{{count}} saltate, nulla è cambiato.',
  },
  partial: {
    summary_one: '{{applied}} di {{approved}} modifiche applicate. {{count}} non riuscite.',
    summary_other: '{{applied}} di {{approved}} modifiche applicate. {{count}} non riuscite.',
    detail_one: 'Le {{applied}} sono salvate. Nulla è cambiato per le {{count}} qui sotto.',
    detail_other: 'Le {{applied}} sono salvate. Nulla è cambiato per le {{count}} qui sotto.',
  },
  stale: {
    summary: '{{applied}} di {{approved}} modifiche applicate.',
    detail_one: '{{count}} è stata modificata da qualcun altro nel frattempo.',
    detail_other: '{{count}} sono state modificate da qualcun altro nel frattempo.',
    reason:
      "{{name}} l'ha cambiato in {{value}} alle {{time}}, prima della tua approvazione, quindi l'ho lasciato. Eccolo di nuovo dal nuovo valore:",
  },
  undone: {
    summary_one: "Annullata. La {{count}} modifica è tornata com'era prima.",
    summary_other: "Annullate. Le {{count}} modifiche sono tornate com'erano prima.",
    detail: "L'annullamento è registrato anche nel log di Amigo e in Menu → Cronologia modifiche.",
  },
  summary: {
    average: '{{amount}} a piatto in media',
    needs_look: 'Da controllare',
    nothing_else: "Nient'altro cambia",
  },
  labels: {
    waiting: 'In attesa di approvazione',
    skip: 'Salta',
    unskip: 'Annulla salto',
    approve_all: 'Approva tutto',
    approve_one: 'Approva {{count}}',
    approve_other: 'Approva {{count}}',
    approve_row: 'Approva',
    reject: 'Rifiuta…',
    reject_confirm: 'Rifiuta',
    back: 'Indietro',
    why: {
      amigo: 'Perché no? (facoltativo, Amigo lo legge)',
      assistant: "Perché no? (facoltativo, l'assistente lo legge)",
    },
    hint: 'Oppure rispondi qui sotto per cambiare qualcosa.',
    show_all_one: 'Mostra tutte le {{count}} modifiche',
    show_all_other: 'Mostra tutte le {{count}} modifiche',
    show_less: 'Mostra meno',
    applying_one: 'Applicazione di {{count}} modifica…',
    applying_other: 'Applicazione di {{count}} modifiche…',
    rows: {
      skipped: 'Saltato',
      applied: 'Applicato',
      failed: 'Non applicato',
      changed: 'Modificato nel frattempo',
      kept: 'Lasciato così',
    },
    history: {
      amigo: 'Apri nel log di Amigo',
      assistant: "Apri nel log dell'assistente",
    },
    undo: 'Annulla',
    to: 'a',
    from: 'da',
    rejected: 'Rifiutato',
    replaced: 'Sostituito',
    expired: 'Scaduto',
  },
};
